let lenis = null;

export const setLenis = (instance) => {
    lenis = instance;
};

export const getLenis = () => lenis;

export const scrollToId = (id) => {
    if (lenis) {
        lenis.scrollTo(id, { duration: 1.6 });
    } else {
        document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
    }
};
